// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import getColor from "@insite/mobius/utilities/getColor";
import { orderUploadErrorsModalStyles } from "@rugby/Overrides/Components/OrderUploadErrorsModal";
import { css } from "styled-components";

orderUploadErrorsModalStyles.exportLinkStyle = {
    css: css`
        color: ${getColor("text.link")};
        font-size: 15px;
        letter-spacing: 0;
        line-height: 30px;
        text-align: right;
        font-weight: 600;

        & svg {
            color: ${getColor("text.link")};
            width: 16px;
            height: 16px;
            margin-right: 5px;
        }

        &:hover {
            color: ${getColor("text.main")};
            & svg {
                color: ${getColor("text.main")};
            }
        }

        ${xScreen.lte("sm")} {
            justify-content: center;
        }
    `,
};

orderUploadErrorsModalStyles.bottomWrapper = {
    css: css`
        &&&&& {
            margin-top: 30px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            ${xScreen.lte("sm")} {
                flex-direction: column-reverse;
            }
        }
    `,
};

orderUploadErrorsModalStyles.buttonsWrapper = {
    css: css`
        margin-top: 0;
        text-align: right;
    `,
};

orderUploadErrorsModalStyles.cancelUploadButton = {
    variant: "secondary",
    css: css`
        margin-left: 10px;
        ${xScreen.lte("sm")} {
            margin-left: 0;
            margin-top: 10px;
            width: 100%;
        }
    `,
};

orderUploadErrorsModalStyles.continueUploadButton = {
    css: css`
        &&&&&& {
            margin-left: 0;
        }
        ${xScreen.lte("sm")} {
            margin-top: 15px;
            width: 100%;
        }
    `,
};
